export const LEGACY_SETTINGS_RESOURCES = {
  colours: {
    title       : 'Colours',
    singular    : 'Colour',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner' ],
    columns     : [
      { key: 'name', label: 'Name' },
      { key: 'hex_code', label: 'Hex Code' }
    ],
    fields: [
      { key: 'name', label: 'Name', type: 'text' },
      { key: 'hex_code', label: 'Hex Code', type: 'text' }
    ]
  },
  currencies: {
    title       : 'Currencies',
    singular    : 'Currency',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner', 'admin' ],
    columns     : [
      { key: 'name', label: 'Name' },
      { key: 'rate', label: 'Rate' },
      { key: 'active', label: 'Active', type: 'boolean' }
    ],
    fields: [
      { key: 'name', label: 'Name', type: 'text' },
      { key: 'rate', label: 'Rate', type: 'number', step: '0.01' },
      { key: 'active', label: 'Active', type: 'checkbox' }
    ]
  },
  groups: {
    title       : 'Groups',
    singular    : 'Group',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner' ],
    columns     : [
      { key: 'name', label: 'Name' },
      { key: 'code', label: 'Code' },
      { key: 'active', label: 'Active', type: 'boolean' }
    ],
    fields: [
      { key: 'name', label: 'Name', type: 'text' },
      { key: 'code', label: 'Code', type: 'text' },
      { key: 'active', label: 'Active', type: 'checkbox' }
    ]
  },
  stores: {
    title       : 'Stores',
    singular    : 'Store',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner' ],
    columns     : [
      { key: 'name', label: 'Name' }
    ],
    fields: [
      { key: 'name', label: 'Name', type: 'text' }
    ]
  },
  designers: {
    title       : 'Designers',
    singular    : 'Designer',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner' ],
    useFormData : true,
    columns     : [
      { key: 'name', label: 'Name' },
      { key: 'active', label: 'Active', type: 'boolean' },
      { key: 'code', label: 'Code' }
    ],
    fields: [
      { key: 'name', label: 'Name', type: 'text' },
      { key: 'active', label: 'Active', type: 'checkbox' },
      { key: 'code', label: 'Code', type: 'text' },
      { key: 'price_tag_logo', label: 'Price Tag Logo', type: 'file', accept: 'image/*' }
    ]
  },
  badges: {
    title       : 'Badges',
    singular    : 'Badge',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner', 'admin' ],
    columns     : [
      { key: 'name', label: 'Name' },
      { key: 'total_item', label: 'Total Item' },
      { key: 'updated_at', label: 'Updated At', type: 'datetime' }
    ],
    fields: [
      { key: 'name', label: 'Name', type: 'text' }
    ],
    showProducts: true
  },
  job_openings: {
    title       : 'Job Openings',
    singular    : 'Job Opening',
    create      : true,
    destroy     : true,
    allowedRoles: [ 'owner' ],
    columns     : [
      { key: 'id', label: 'ID' },
      { key: 'title', label: 'Title' },
      { key: 'location', label: 'Location' },
      { key: 'active', label: 'Active', type: 'boolean' }
    ],
    fields: [
      { key: 'title', label: 'Title', type: 'text' },
      { key: 'location', label: 'Location', type: 'text' },
      { key: 'description', label: 'Description', type: 'textarea' },
      { key: 'active', label: 'Active', type: 'checkbox' }
    ]
  }
}
